import { useEffect } from "react";
import { useParams } from "react-router-dom";
import CreateForwardingDirectiveEntryForm from "../../components/CreateForwardingDirectiveEntryForm";
import CreateMaintenanceForwardingDirectiveError from "../../components/CreateMaintenanceForwardingDirectiveError";
import CreateMaintenanceForwardingDirectiveLoading from "../../components/CreateMaintenanceForwardingDirectiveLoading";
import CreateMaintenanceForwardingSelectDirectiveEntry from "../../components/CreateMaintenanceForwardingSelectDirectiveEntry";
import { useMaintenanceForwardingsShowDirectiveDetails } from "../../hooks/useMaintenanceForwardingsShowDirectiveDetails";
import { useCreateForwardingsFormStore } from "../../stores/createForwardingsFormStore";

const CompanyMaintenanceWorkflowsForwardingsCreate = () => {
  const { workflowId, directiveEntryType } = useParams();

  const { initForm } = useCreateForwardingsFormStore();

  const {
    data: directiveDetails,
    isPending: directiveDetailsIsPending,
    isError: directiveDetailsIsError,
    error: directiveDetailsError = {} as any,
    refetch: refetchDirectiveDetails,
  } = useMaintenanceForwardingsShowDirectiveDetails({
    workflowId,
    directiveEntryKlass: directiveEntryType,
  });

  useEffect(initForm, []);

  if (!directiveEntryType) {
    return <CreateMaintenanceForwardingSelectDirectiveEntry />;
  }

  if (directiveDetailsIsPending) {
    return <CreateMaintenanceForwardingDirectiveLoading />;
  }

  if (directiveDetailsIsError) {
    return (
      <CreateMaintenanceForwardingDirectiveError
        statusCode={directiveDetailsError?.status}
        refetchFunction={refetchDirectiveDetails}
        message={directiveDetailsError?.response?.data?.errors?.base?.[0]}
      />
    );
  }

  return (
    <CreateForwardingDirectiveEntryForm
      directiveDetails={directiveDetails}
    />
  );
}

export default CompanyMaintenanceWorkflowsForwardingsCreate;
